/**
 * Utility function to register the world map with ECharts
 */

// World map data is already included in the project
import worldJson from './world.json';

export const registerMap = (echarts) => {
  try {
    // Check if the map is already registered
    const maps = echarts.getMap('world');
    if (!maps) {
      console.log('Registering world map with ECharts');
      echarts.registerMap('world', worldJson);
    } else {
      console.log('World map already registered with ECharts');
    }
  } catch (error) {
    console.error('Error registering world map:', error);
  }
}; 